import { useCallback, useMemo, useState } from 'react';
import useFeatures from './useFeatures';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useTimeFilters(defaultSearchParams) {
  const features = useFeatures();

  const filters = useMemo(
    () => ({
      createdPeriod: null,
      modifiedPeriod: null,
      timeApprovalStatuses: [],
      timeClientApprovalStatuses: [],
      timeBillableTypes: [],
      timeInvoiced: null,
      timeOffTypes: [],
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const timeSearchParamsConfig = useMemo(
    () => ({
      createdPeriod: searchParamsConfig.createdPeriod,
      modifiedPeriod: searchParamsConfig.modifiedPeriod,
      timeBillableTypes: searchParamsConfig.timeBillableTypes,
      timeOffTypes: searchParamsConfig.timeOffTypes,
      timeApprovalStatuses: searchParamsConfig.timeApprovalStatuses,
      timeClientApprovalStatuses: searchParamsConfig.timeClientApprovalStatuses,
      timeInvoiced: searchParamsConfig.timeInvoiced,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback(
    (params) => ({
      createdStart: params.createdPeriod?.start ?? undefined,
      createdEnd: params.createdPeriod?.end ?? undefined,
      modifiedStart: params.modifiedPeriod?.start ?? undefined,
      modifiedEnd: params.modifiedPeriod?.end ?? undefined,
      timeBillableTypeId: params.timeBillableTypes?.map((v) => v.id),
      timeOffTypeId: params.timeOffTypes?.map((v) => v.id),
      timeApprovalStatusId: params.timeApprovalStatuses?.map((v) => v.id),
      timeClientApprovalStatusId: params.timeClientApprovalStatuses?.map((v) => v.id),
      timeInvoiced: params.timeInvoiced ?? undefined,
    }),
    [],
  );

  const mapClickThroughParams = useCallback(
    (filters) => ({
      createdPeriod: filters.createdPeriod ?? undefined,
      modifiedPeriod: filters.modifiedPeriod ?? undefined,
      timeBillableTypeId: filters.timeBillableTypes?.map((v) => v.id),
      timeOffTypeId: filters.timeOffTypes?.map((v) => v.id),
      timeApprovalStatusId: filters.timeApprovalStatuses?.map((v) => v.id),
      timeClientApprovalStatusId: features.clientApprovals
        ? filters.timeClientApprovalStatuses?.map((v) => v.id)
        : undefined,
      timeInvoiced: filters.timeInvoiced ?? undefined,
    }),
    [features],
  );

  return useMemo(
    () => ({ filters, searchParamsConfig: timeSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams }),
    [filters, timeSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams],
  );
}
